/* Face Dunk — shared storefront helpers (quick-add to cart drawer) */
(function () {
  function routes() { return window.routes || {}; }

  window.fdAdd = async function (btn) {
    var id = btn.getAttribute('data-variant');
    if (!id) { return true; }
    var orig = btn.innerHTML;
    btn.setAttribute('disabled', 'disabled');
    btn.innerHTML = 'Adding…';
    try {
      var drawer = document.querySelector('cart-drawer');
      var item = { id: Number(id), quantity: Number(btn.getAttribute('data-qty') || 1) };
      var sp = btn.getAttribute('data-selling-plan');
      if (sp) { item.selling_plan = Number(sp); }
      var payload = { items: [item] };
      if (drawer) { payload.sections = ['cart-drawer']; payload.sections_url = window.location.pathname; }
      var r = await fetch((routes().cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      var data = await r.json();
      if (r.ok) {
        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          drawer.renderContents(data);
        }
        if (drawer && typeof drawer.open === 'function') { drawer.open(btn); }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        btn.innerHTML = 'Added ✓';
        setTimeout(function () { btn.innerHTML = orig; btn.removeAttribute('disabled'); }, 1200);
        return false;
      }
    } catch (e) {}
    btn.innerHTML = orig;
    btn.removeAttribute('disabled');
    return false;
  };
})();
